import { OnboardingFinalizedState } from '../enums/onboardingFinalizedState'
import { OnboardingSetupStep } from '../types'

export const isOnboardingFinalized = (
  step: OnboardingFinalizedState | OnboardingSetupStep,
): step is OnboardingFinalizedState =>
  step === OnboardingFinalizedState.Completed || step === OnboardingFinalizedState.Skipped
